import React from 'react';

interface TruncatedListProps<T> {
  items: T[] | undefined | null;
  max?: number;
  renderItem: (item: T, index: number) => React.ReactNode;
  renderMore: (remainingCount: number) => React.ReactNode;
  className?: string;
}

export const TruncatedList = <T,>({
  items,
  max = 3,
  renderItem,
  renderMore,
  className = 'flex flex-wrap gap-2',
}: TruncatedListProps<T>) => {
  if (!items || items.length === 0) {
    return null;
  }

  const visibleItems = items.slice(0, max);
  const remainingCount = items.length - max;

  return (
    <div className={className}>
      {visibleItems.map((item, index) => renderItem(item, index))}
      {remainingCount > 0 && renderMore(remainingCount)}
    </div>
  );
};
